export const iconFontAwesomeMapsIndustry = (
	<i className="fa-solid fa-industry"></i>
);
